module.exports = __webpack_public_path__ + "img/scale.4df70547.svg";